export default __webpack_public_path__ + "static/media/Citations.a749089b.png";